import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { DetailTable } from "MODULES/shared/components/DetailTable";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import Section from "MODULES/shared/components/Section";
import { FULL_NAME } from "MODULES/users/constants";
import { shortDateYYandTime } from "LIB/formatters/date";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { UPDATED_AT, UPDATED_BY } from "APP_ROOT/constants";
import { DESCRIPTION } from "MODULES/parts/constants";
import { RELEASE_FOR_SHIPMENT_DETAILS, RELEASED } from "../../../../constants";

const UpdatedByDetails = ({ row }) => {
  if (!row.get(RELEASED)) return <td />;

  return (
    <td>
      Updated By{"   "}
      {getFirstNameLastInitial(row.getIn([UPDATED_BY, FULL_NAME]))}&nbsp;on{" "}
      {shortDateYYandTime(row.get(UPDATED_AT))}
    </td>
  );
};

export function Details({ salesOrder }) {
  const reasons = salesOrder.get(RELEASE_FOR_SHIPMENT_DETAILS);

  if (!reasons) return null;
  if (reasons.length === 0) return null;
  return [
    <hr />,
    <Section title="Release Details" editable={false}>
      <DetailTable>
        <tr>
          <th>Reason</th>
          <th>Release Details</th>
        </tr>
        {reasons.map(r => (
          <tr>
            <td>{r.get(DESCRIPTION)}</td>
            <UpdatedByDetails row={r} />
          </tr>
        ))}
      </DetailTable>
    </Section>
  ];
}

Details.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(withSalesOrder(Details));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/ReleaseDetails/ReleaseDetails.jsx